import store from '@/store'
const base = {
  inheritAttrs: false,
  methods: {
    strToLower: function(str) {
      return str.toLowerCase();
    },
    strToUpper: function(str) {
      return str.toUpperCase();
    },
    auth: function(token = null) {
      if (token != null) {
        localStorage.clear();
        return false;
      } else {
        if (localStorage.getItem('token') != null) {
          return true;
        } else {
          return false;
        }
      }
    },
    reloadHomeWork: function name(student_id) {
      this.homeWorkData(student_id);
      this.homeWorkData(student_id, 'eski')
      return true
    },
    /// D A T A   F E T C H   S T A R T
    authData: async function (username, password) {
      await store.dispatch('auth/login', {username: username, password: password}).then(
        () => {
          return true;
        },
        error => {
          setTimeout(() => {
            if (error.response.data !== undefined && typeof error.response.data.message !== undefined) {
              console.log(error.response.data.message)
            }
            return false;
          }, 2000)
        }
      );
    },
    authDataWithToken: async function (token) {
      await store.dispatch('auth/login_with_token', token).then(
        () => {
          return true;
        },
        error => {
          setTimeout(() => {
            if (error.response.data !== undefined && typeof error.response.data.message !== undefined) {
              console.log(error.response.data.message)
            }
            return false;
          }, 2000)
        }
      );
    },
    incompleteCompletionData: async function (student_id) {
      await store.dispatch('exam/incompleteCompletion', student_id).then(
        () => {
          return true;
        },
        error => {
          if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
            console.log(error.response.data.message)
          }
          return false
        }
      );
    },
    incompleteCompletionOnlineData: async function (student_id) {
      await store.dispatch('exam/incompleteCompletionOnline', student_id).then(
        () => {
          return true;
        },
        error => {
          if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
            console.log(error.response.data.message)
          }
          return false
        }
      );
    },
    homeWorkData: async function (student_id, status = 'yeni') {
      let dispatch = status == 'yeni' ? 'exam/homeWork' : 'exam/oldHomeWork'
      await store.dispatch(dispatch, student_id).then(
        () => {
          console.log("Veri geldi")
          return true;
        },
        error => {
          if (error.response !== undefined && error.response.data !== undefined && typeof error.response.data.message !== undefined) {
            return true;
          }
          return false
        }
      );
    },
    /// D A T A   F E T C H   E N D
    time: function (d = null) {
      let date = '';
      if (d == null) date = new Date()
      else date = new Date(moment(d, "YYYY-MM-DD HH:mm:ss").toDate()) // eslint-disable-line
      return Math.floor(date.getTime() / 1000)
    },
    timeCheck(exam_start_time, exam_finish_time, total_second, started_time = null) {
      let ret = 0
      exam_start_time = this.time(exam_start_time)
      exam_finish_time = this.time(exam_finish_time)
      // console.log(exam_start_time, exam_finish_time)
      total_second = Number(total_second)
      started_time = Number(started_time)
      if (started_time == null || started_time == 0) { // we have time
        ret = total_second
        if (this.time() > this.time(exam_finish_time)) {
          ret = 0
        }
      } else {
        let now = this.time();
        if (now < exam_finish_time) {
          let target_time = started_time + total_second;
          if (target_time > exam_finish_time) {
            target_time = exam_finish_time
          }


          ret = target_time - now
          //console.log(target_time, now)
        }
      }
      return ret < 0 ? 0 : ret
    },
    dateConverter(date, time = false, second = false) {
      let new_date = null
      if (typeof date == 'string') {
        new_date = new Date(moment(date, "YYYY-MM-DD HH:mm:ss").toDate()) // eslint-disable-line
      } else {
        new_date = new Date(moment(date).toDate()) // eslint-disable-line
      }
      
      let ret = new_date.toLocaleDateString("tr-TR", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      if (time) {
        if (second) {
          ret = ret + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        } else {
          ret = ret + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit' })
        }
      } else if (time == null) {
        ret = new_date.toLocaleDateString("tr-TR", { weekday: 'long', month: 'long', day: 'numeric' }) + ' - ' + new_date.toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit' })
      }
      return ret
    },
    secondToTime(time) {
      let minutes = Math.floor(time / 60)
      let seconds = ((time % 60) / 1).toFixed(0)
      if (seconds == 60) {
        seconds = 59
      }
      return {
        m: Number(minutes),
        s: Number(seconds)
      }
    },
    authClean: function () {
      localStorage.clear()
      store.dispatch('auth/logout');
      store.dispatch('exam/logout');
      // localStorage.removeItem('token')
      this.$router.push({ name: 'Login', query: { cikis: '🐾' } })
    },
    deviceTimeNConnectionCheck: function () {
      let second = 20
      let sysAlert = null
      let sysConAlert = null
      setInterval(() => {

        if (! navigator.onLine) {

          if (sysConAlert == null) {
            sysConAlert = $.confirm({ // eslint-disable-line
              title: 'Bağlantı Sorunu',
              content: 'Evdeki Öğretmen uygulamasını kullanmaya devam edebilmeniz için cihazınızın internet bağlantısının olması gerekir.',
              type: 'red',
              typeAnimated: true,
              backgroundDismissAnimation: 'glow',
              buttons: {
                test: {
                  isHidden: true,
                  isDisabled: true,
                },
              }
            })
          }

        } else {

          if (sysConAlert != null) {
            sysConAlert.close()
            sysConAlert = null
          }
          
          second = second + 1
          if (second > 20) {
            fetch('https://apiv2.bilfen.com/api/time-zone')
              .then((response) => {
                return response.json();
              })
              .then( (data) => {

                if (sysAlert != null) {
                  sysAlert.close()
                  sysAlert = null
                }
                
                let device_time = this.time();
                if (data.unixtime != undefined) {
                  if (data.unixtime < (device_time - 60) || data.unixtime > (device_time + 60) && sysAlert == null) {
                    sysAlert = $.confirm({ // eslint-disable-line
                      title: 'Cihaz zaman ayarınız yanlış!',
                      content: 'Evdeki Öğretmen projesini kullanmaya devam etmeniz için cihaz zaman ayarlarınızı doğru bir şekilde yapmalısınız. Aksi takdirde sistemi kullanımınıza izin verilmez. <br><small class="text-danger"><strong>Sizin Saat Ayarınız</strong>: ' + this.dateConverter((device_time * 1000), true, true) + ' </small> <br><small class="text-success"><strong>Doğru Ayar: </strong>' + this.dateConverter((data.unixtime * 1000), true, true) + '</small>',
                      type: 'red',
                      typeAnimated: true,
                      backgroundDismissAnimation: 'glow',
                      buttons: {
                        test: {
                          isHidden: true,
                          isDisabled: true,
                        },
                      }
                    })
                  }
                }
            });
            second = 0
          }
        }
      }, 1000);
    }
  
  },
  computed: {
    getYear: function() {
      let year = new Date();
      return year.getFullYear();
    },
    appName: function() {
      return this.$store.state.app.name;
    },
    appVersion: function() {
      return this.$store.state.app.version;
    },
  }
}
export default base;